import React from "react";

function FooterSection() {

	return (
	<footer className="footer-background">
        <div className="container">
          <div className="row mb-3">
          <div className="col-md-6 text-center footer-link-contents px-2  pr-3">
              <div className="nav footer-links">
              <span className="nav-item"><a href="https://ecoassist.com.br/quem-somos/" rel="noreferrer" target="blank"  className="nav-link">Sobre Nós</a></span>
              <span className="nav-item"><a href="https://ecoassist.com.br/blog/" rel="noreferrer"  className="nav-link" target="blank"  >Blog</a></span>
              <span className="nav-item"><a href="https://ecoassist.com.br/contato/" rel="noreferrer" className="nav-link" target="blank" >Contato</a></span>
              <span className="nav-item"><a href="https://ecoassistloja.com.br/files/termos/Termos%20de%20Uso%20e%20de%20Privacidade.pdf" rel="noreferrer" target="blank" className="nav-link">Termos de uso</a></span>
              </div>

            </div>
            <div className="col-md-2 text-center footer-inc p-3">©2024
              Ecoassist</div>
            <div className="col-md-4 text-center  footer-icons-contents">
              <div className="social-icons">
              <a href="https://www.facebook.com/ecoassist" target="_blank" rel="noreferrer">
                <i className="bi bi-facebook footer-icons"></i>
              </a>
              <a href="https://www.instagram.com/ecoassist" target="_blank" rel="noreferrer">
                <i className="bi bi-instagram footer-icons"></i>
              </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
	);
}

export default FooterSection;



